// Phase 19 · Community V2 · Block user modal
import React, { useState } from "react";
import { X, Ban } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function BlockUserModal({ username, onClose, onBlocked }) {
    const [reason, setReason] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        setBusy(true);
        try {
            const r = await fetch(`${API}/api/community/settings/block`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    blocked_username: username,
                    reason: reason.trim(),
                }),
            });
            if (!r.ok) {
                const err = await r.json().catch(() => ({}));
                toast.error(err.detail?.error || "Block failed");
                return;
            }
            toast.success(`@${username} blocked`);
            onBlocked?.();
            onClose?.();
        } catch { toast.error("Network error"); }
        finally { setBusy(false); }
    };

    return (
        <div
            className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
            data-testid="block-user-modal"
        >
            <div className="bg-[#111111] border border-[#1A1A1A] rounded-2xl w-full max-w-md p-6 relative">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute top-4 right-4 text-neutral-500 hover:text-neutral-200"
                    data-testid="block-modal-close"
                >
                    <X size={18} />
                </button>
                <div className="flex items-center gap-2 mb-4">
                    <Ban size={18} className="text-[#FAFAFA]" />
                    <h2 className="text-lg font-semibold text-neutral-100">Block @{username}?</h2>
                </div>
                <p className="text-xs text-neutral-400 mb-4">
                    Blocking is reciprocal. You won't see each other's posts, messages, or channel activity.
                    You can unblock any time from Settings → Blocked list.
                </p>
                <label className="block text-xs text-neutral-400 mb-1">Reason (optional, private)</label>
                <textarea
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    maxLength={200}
                    rows={2}
                    placeholder="Only visible to you"
                    className="w-full bg-[#0A0A0A] border border-[#1A1A1A] rounded-lg px-3 py-2 text-sm text-neutral-100 focus:outline-none focus:border-[#FAFAFA]"
                    data-testid="block-reason-input"
                />
                <div className="flex justify-end gap-2 mt-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 text-sm text-neutral-400 hover:text-neutral-200"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={submit}
                        disabled={busy}
                        className="px-4 py-2 text-sm bg-[#FAFAFA] hover:bg-[#FAFAFA]/80 text-white font-semibold rounded disabled:opacity-40"
                        data-testid="block-submit"
                    >
                        {busy ? "..." : "Block"}
                    </button>
                </div>
            </div>
        </div>
    );
}
